import React from 'react';
import DepartmentTemplate from './DepartmentTemplate';

const DeptValOise95 = () => {
  return (
    <DepartmentTemplate
      department="Val-d'Oise"
      departmentNumber="95"
      cities="Cergy, Argenteuil, Sarcelles, Pontoise"
      region="Île-de-France"
    />
  );
};

export default DeptValOise95;
